module.exports = __webpack_public_path__ + "static/media/pdf.1643cf14.png";